import { useEffect, useRef, useState } from "react";
import { getVideoCallContact } from "../../../../../util/APIUtils";


export const usePictureViewerHook = (props) => {
    const initialContactDetails = {
        firstName: '',
        lastName: ''
    };
    const modalRef = useRef();
    const [isOpen, setIsOpen] = useState(false);
    const [videoContactDetails, setVideoContactDetails] = useState(initialContactDetails);
    const [isLoading, setIsLoading] = useState(false);

    const getContactDetails = async () => {
        try {
            setIsLoading(true);
            const response = await getVideoCallContact(props.details.contactId);
            setVideoContactDetails(response);
        } catch (e) {
            // Error loading contact details; state remains unchanged
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            getContactDetails();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- getContactDetails depends on props.details.contactId, isOpen
    }, [isOpen]);

    const toggleModal = () => {
        setVideoContactDetails(initialContactDetails);
        setIsOpen(!isOpen);
        modalRef.current.toggleModal();
    };

    return { videoContactDetails, isLoading, modalRef, toggleModal };
};